import React from 'react';

import { Card } from 'components';

import * as styles from './styles.module.scss';

function Achievement({ children, className, image, title }) {
  return (
    <Card className={className}>
      <div className={styles.content}>
        {image}
        <div>
          <p className={styles.title}>{title}</p>
          {children}
        </div>
      </div>
    </Card>
  );
}

export default Achievement;
